import { FaListAlt } from "../../utils/icons";

interface WorkListButtonProps {
  onClick: () => void;
  compact?: boolean;
}

export function WorkListButton({ onClick, compact = false }: WorkListButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`sidebar-btn flex items-center gap-1 text-[10px] text-fg-muted hover:text-white ${
        compact ? "h-6 px-1.5" : "h-7 px-2"
      }`}
      title="Back to work list"
      aria-label="Back to work list"
    >
      <FaListAlt className="w-3 h-3" />
    </button>
  );
}
